import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "addon-overview" }
const _hoisted_3 = { class: "wiki-panel" }
const _hoisted_4 = ["aria-label"]

import LocalizedTextWrapper from '@/components/feedback/LocalizedTextWrapper.vue';
import WikiBreadCrumbs from '@/components/header/WikiBreadCrumbs.vue';
import WikiPlayCta from '@/components/view/information/WikiPlayCta.vue';
import SchemaImage from '@/components/view/SchemaImage.vue';
import { getImagePathByID } from '@/helpers/images';

export default /*@__PURE__*/_defineComponent({
  __name: 'Trapper',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_LocaleLink = _resolveComponent("LocaleLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WikiBreadCrumbs),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('trapperGuide.heading')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SchemaImage, {
        class: "addon-image",
        src: _unref(getImagePathByID)('features', 'trapper'),
        alt: _ctx.$t('trapper.name'),
        description: _ctx.$t('trapper.name')
      }, null, 8, ["src", "alt", "description"]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('trapperGuide.intro')), 1)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('trapperGuide.limits')), 1),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "trapperGuide.limitText" })
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('trapperGuide.order')), 1),
      _createElementVNode("ol", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (number) => {
          return _createElementVNode("li", { key: number }, [
            _createVNode(LocalizedTextWrapper, {
              keypath: `trapperGuide.step${number}`
            }, null, 8, ["keypath"])
          ])
        }), 64))
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('trapperGuide.timer')), 1)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('trapperGuide.swordTitle')), 1),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "trapperGuide.swordText" })
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('trapperGuide.visibilityTitle')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('trapperGuide.visibilityText')), 1)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('trapperGuide.examples')), 1),
      _createElementVNode("ul", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (number) => {
          return _createElementVNode("li", { key: number }, _toDisplayString(_ctx.$t(`trapperGuide.example${number}`)), 1)
        }), 64))
      ])
    ]),
    _createElementVNode("nav", {
      class: "wiki-nav",
      "aria-label": _ctx.$t('wiki.title')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.rules')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'expansions' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.addonsTitle')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_4),
    _createVNode(WikiPlayCta)
  ]))
}
}

})